<template>
  <div class="col-md-4">
    <div class="p-a-md">
      <span class="h5 _500">Reports</span><br>
      <small class="text-muted">Download Report In CSV Format</small>
      <ul class="list no-padding">
        <br>
        <li 
          v-for="report in reports" 
          :key="report.type" 
          class="list-item p-a-0">
          <div class="list-body">
            <div class="m-y-sm pull-left">
              <span>{{ report.title }}</span>
              <br><small class="text-muted">{{ report.desc }}</small>
            </div>
            <div class="m-y-sm pull-right">
              <a 
                :href="getDownloadUrl(report.type)" 
                class="text-muted">Download</a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            reports: [
                {
                    type: 'top_outlet_sales',
                    title: `Top ${this.trans('general.outlet')} Sales `,
                    desc: 'View of the sales prior of month to date',
                },
                {
                    type: 'top_outlet_pax',
                    title: `Top ${this.trans('general.outlet')} Pax `,
                    desc: 'View of the top pax prior of month to date',
                },
                {
                    type: 'top_item_sales',
                    title: 'Top Product Sales',
                    desc: 'View of the top item sales of month to date',
                },
                {
                    type: 'top_voided_receipt',
                    title: `Top ${this.trans(
                        'general.outlet',
                    )} Voided Receipt `,
                    desc: `View of ${this.trans(
                        'general.outlet',
                    ).toLowerCase()} with voided sales`,
                },
                {
                    type: 'top_average_receipt',
                    title: 'Top Average Spending Per Receipt',
                    desc: 'View of top average spending per receipt',
                },
                {
                    type: 'top_average_pax',
                    title: 'Top Average Spending Per Pax',
                    desc: 'View of top average spending per pax',
                },
                {
                    type: 'outlet_target_sales',
                    title: `${this.trans('general.outlet')} Target`,
                    desc: `Overview of All ${this.trans(
                        'general.outlet',
                    )} Target Report`,
                },
            ],
        };
    },

    methods: {
        getDownloadUrl(type) {
            let url = Laroute.route('franchise.dashboard.exportStatsAsCSV', {
                type: type,
            });
            return url;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/dashboard/dashboard-report.vue